export const Movies = [
  {
    name: "Batman: DC Films",
    desc: "Lorem ipdsajdnsidjm pdsajdnsidjm dhfdkafd djfadkfad jdkaedje ascdhakfwebjpdsajdnsidjm dhfdkafd djfadkfad jdkaedjei ascdhakfwebj dhfdkafd djfadkfad jdkaedjei ascdhakfwebj",
    titleImage: "bg2.jpg",
    type: "POPULAR",
    image: "bg2.jpg",
    category: "Fantasy",
    language: "English",
    year: "2015",
    time: "3hr",
    video: "",
    rate: 1.4,
    reviews: 23,
  },
  {
    name: "Jungle Justice",
    desc: "Lorem ipdsajdnsidjm pdsajdnsidjm dhfdkafd djfadkfad jdkaedje ascdhakfwebjpdsajdnsidjm dhfdkafd djfadkfad jdkaedjei ascdhakfwebj dhfdkafd djfadkfad jdkaedjei ascdhakfwebj",
    titleImage: "bg.jpg",
    image: "bg.jpg",
    type: "POPULAR",
    category: "Horror",
    language: "English",
    year: "2015",
    time: "3hr",
    video: "",
    rate: 3.1,
    reviews: 23,
  },
  {
    name: "Three Idiots",
    desc: "Lorem ipdsajdnsidjm pdsajdnsidjm dhfdkafd djfadkfad jdkaedje ascdhakfwebjpdsajdnsidjm dhfdkafd djfadkfad jdkaedjei ascdhakfwebj dhfdkafd djfadkfad jdkaedjei ascdhakfwebj",
    titleImage: "1.jpg",
    image: "1.jpg",
    type: "POPULAR",
    category: "Thriller",
    language: "English",
    year: "2015",
    time: "3hr",
    video: "",
    rate: 3.4,
    reviews: 23,
  },
  {
    name: "Harvesters",
    desc: "Lorem ipdsajdnsidjm pdsajdnsidjm dhfdkafd djfadkfad jdkaedje ascdhakfwebjpdsajdnsidjm dhfdkafd djfadkfad jdkaedjei ascdhakfwebj dhfdkafd djfadkfad jdkaedjei ascdhakfwebj",
    titleImage: "bg2.jpg",
    image: "bg2.jpg",
    type: "POPULAR",
    category: "Comedy",
    language: "English",
    year: "2015",
    time: "3hr",
    video: "",
    rate: 4.0,
    reviews: 23,
  },
  {
    name: "The Ruach Way",
    desc: "Lorem ipdsajdnsidjm pdsajdnsidjm dhfdkafd djfadkfad jdkaedje ascdhakfwebjpdsajdnsidjm dhfdkafd djfadkfad jdkaedjei ascdhakfwebj dhfdkafd djfadkfad jdkaedjei ascdhakfwebj",
    titleImage: "1.jpg",
    image: "1.jpg",
    type: "POPULAR",
    category: "Family",
    language: "English",
    year: "2015",
    time: "3hr",
    video: "",
    rate: 3.9,
    reviews: 23,
  },
  {
    name: "Breath Of Life",
    desc: "Lorem ipdsajdnsidjm pdsajdnsidjm dhfdkafd djfadkfad jdkaedje ascdhakfwebjpdsajdnsidjm dhfdkafd djfadkfad jdkaedjei ascdhakfwebj dhfdkafd djfadkfad jdkaedjei ascdhakfwebj",
    titleImage: "1.jpg",
    image: "1.jpg",
    type: "POPULAR",
    category: "Family",
    language: "English",
    year: "2015",
    time: "3hr",
    video: "",
    rate: 4.4,
    reviews: 23,
  },
  {
    name: "The Hate You Give",
    desc: "Lorem ipdsajdnsidjm pdsajdnsidjm dhfdkafd djfadkfad jdkaedje ascdhakfwebjpdsajdnsidjm dhfdkafd djfadkfad jdkaedjei ascdhakfwebj dhfdkafd djfadkfad jdkaedjei ascdhakfwebj",
    titleImage: "1.jpg",
    image: "1.jpg",
    type: "POPULAR",
    category: "Action",
    language: "English",
    year: "2015",
    time: "3hr",
    video: "",
    rate: 3.4,
    reviews: 23,
  },
  {
    name: "Constantine",
    desc: "Lorem ipdsajdnsidjm pdsajdnsidjm dhfdkafd djfadkfad jdkaedje ascdhakfwebjpdsajdnsidjm dhfdkafd djfadkfad jdkaedjei ascdhakfwebj dhfdkafd djfadkfad jdkaedjei ascdhakfwebj",
    titleImage: "1.jpg",
    image: "1.jpg",
    type: "POPULAR",
    category: "Horror",
    language: "English",
    year: "2015",
    time: "3hr",
    video: "",
    rate: 3.4,
    reviews: 23,
  },
  {
    name: "AVENGERS: END GAME",
    desc: "Lorem ipdsajdnsidjm pdsajdnsidjm dhfdkafd djfadkfad jdkaedje ascdhakfwebjpdsajdnsidjm dhfdkafd djfadkfad jdkaedjei ascdhakfwebj dhfdkafd djfadkfad jdkaedjei ascdhakfwebj",
    titleImage: "1.jpg",
    image: "1.jpg",
    type: "POPULAR",
    category: "Western",
    language: "English",
    year: "2015",
    time: "3hr",
    video: "",
    rate: 3.9,
    reviews: 23,
  },
  {
    name: "Apocalypse",
    desc: "Lorem ipdsajdnsidjm pdsajdnsidjm dhfdkafd djfadkfad jdkaedje ascdhakfwebjpdsajdnsidjm dhfdkafd djfadkfad jdkaedjei ascdhakfwebj dhfdkafd djfadkfad jdkaedjei ascdhakfwebj",
    titleImage: "1.jpg",
    image: "1.jpg",
    type: "POPULAR",
    category: "Western",
    language: "English",
    year: "2015",
    time: "3hr",
    video: "",
    rate: 3.8,
    reviews: 23,
  },
  {
    name: "Rooted In Love",
    desc: "Lorem ipdsajdnsidjm pdsajdnsidjm dhfdkafd djfadkfad jdkaedje ascdhakfwebjpdsajdnsidjm dhfdkafd djfadkfad jdkaedjei ascdhakfwebj dhfdkafd djfadkfad jdkaedjei ascdhakfwebj",
    titleImage: "1.jpg",
    image: "1.jpg",
    type: "POPULAR",
    category: "Western",
    language: "English",
    year: "2015",
    time: "3hr",
    video: "",
    rate: 3.4,
    reviews: 23,
  },
];
